import clientAxios from "../../client";

import { formatQueryString } from "@/common/utils/common";

import type { QueryType } from "@/common/types/common";
import type {
  VersionOwnerType,
  VersionRelatedPayloadType,
  VersionRelationType,
} from "@/common/types/common/version";

export async function versionRelatedList(
  ownerType: VersionOwnerType,
  ownerId: string,
  query?: QueryType & { relation_type?: VersionRelationType },
) {
  const queryString = formatQueryString(query);

  return await clientAxios.get(
    `admin/version/${ownerType}/${ownerId}/list${queryString}`,
  );
}

export async function versionRelatedListId(
  ownerType: VersionOwnerType,
  ownerId: string,
  relationType: VersionRelationType,
) {
  const queryString = formatQueryString({ relation_type: relationType });

  return await clientAxios.get(
    `admin/version/${ownerType}/${ownerId}/list/id${queryString}`,
  );
}

export async function versionRelatedCreate(
  ownerType: VersionOwnerType,
  ownerId: string,
  payload: VersionRelatedPayloadType,
) {
  return await clientAxios.post(
    `admin/version/${ownerType}/${ownerId}/create`,
    payload,
  );
}

export async function versionRelatedDelete(itemId: string) {
  return await clientAxios.del(`admin/version/related/${itemId}/delete`);
}
